import request from './request'

/**
 * 取得目前公告梯次的顯示用時間。
 * @returns {Promise}
 */
function getCurrent() {
  return request({
    url: '/academicSetting/current',
    method: 'get',
  })
}

export default {
  getCurrent,
}
